<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        tipoEquipe="esb"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        tipoEquipe="esb"
      />
    </div>

    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Crianças" active>
          <template #title> <i class="icofont-list"></i> Crianças </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
                :setGreen="exibirCadastrosVerdes"
              />
            </div>
            <div class="info-table-item">
              <SelectMes v-model="mes" />
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="escovacao-supervisionada"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch"
          />
        </b-tab>

        <b-tab title="Percentual">
          <template #title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <TabelaPercentual
            :loading="loading"
            :municipio="dadosPercentualMunicipio"
            :equipe="dadosPercentualEquipe"
            :micro_area="dadosPercentualMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="microArea"
            :tipoResultado="tipoResultadoPercentual"
            @changeTipoResultado="changeTipoResultadoPercentual"
          />
          <GraficoPercentual
            :equipe="equipe"
            :micro_area="microArea"
            :tipoResultado="tipoResultadoGrafico"
            @changeTipoResultado="changeTipoResultadoGrafico"
            ref="graficoPercentual"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './components/Subtitle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { dataFields } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaPercentual from './components/TabelaPercentual.vue'
import GraficoPercentual from './components/GraficoPercentual.vue'
import SelectMes from '../../components/SelectMes.vue'

export default {
  name: 'EscovacaoSupervisionada',
  components: {
    Subtitle,
    PulseLoader,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    TabelaCadastros,
    SelectsV2,
    TabelaPercentual,
    GraficoPercentual,
    SelectMes,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      microArea: '',
      microAreas: [],
      cadastros: [],
      cadastrosOriginais: [],
      dadosPercentualMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosTabelaPercentual: [],
      dadosGraficoPercentual: [],
      loading: false,
      tabsActive: 0,
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      filterSearchTable: false,
      dataFields: { ...dataFields },
      mes: null,
      tipoResultadoPercentual: 'quadrimestral',
      tipoResultadoGrafico: 'quadrimestral',
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable) return this.filterSearchTable

      const resultado = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.mes,
        this.equipe
      )
      return resultado || []
    },
  },
  watch: {
    mes(valor) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.filterSearchTable = false

      if (valor) {
        this.handleExibirVerdes(true)
      }
    },
  },
  methods: {
    /**
     * Aplica os filtros de exibição dos cadastros.
     *
     * @param {Boolean} vermelho Exibe apenas cadastros pendentes.
     * @param {Boolean} verde Exibe apenas cadastros concluídos.
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.setRed = vermelho
      this.exibirCadastrosVermelhos = vermelho
      this.exibirCadastrosVerdes = verde && !vermelho
    },

    /**
     * Atualiza o resultado da busca da tabela.
     *
     * @param {Object} item Objeto retornado pelo componente da tabela.
     */
    filterSearch(item) {
      this.filterSearchTable = item.filter || false
    },

    /**
     * Exibe apenas os registros vermelhos.
     *
     * @param {Boolean} valor Estado do filtro.
     */
    handleExibirVermelhos(valor) {
      this.filtros(valor, false)
      this.mes = null
    },

    /**
     * Exibe apenas os registros verdes.
     *
     * @param {Boolean} valor Estado do filtro.
     */
    handleExibirVerdes(valor) {
      this.filtros(false, valor)
    },

    /**
     * Atualiza a equipe selecionada e recarrega os dados.
     *
     * @param {Object} event Equipe selecionada.
     * @returns {Promise<void>}
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) this.$refs.table.search = ''

      this.equipe = event
      this.microArea = ''
      this.mes = null
      this.resetDadosMicroArea()

      if (event) {
        this.tabsActive = 0
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetDadosEquipe()
        this.resetCadastros()
      }

      this.setarPercentualEquipe()
    },

    /**
     * Atualiza a microárea selecionada e recarrega os dados.
     *
     * @param {Object} event Microárea selecionada.
     * @returns {Promise<void>}
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.tabsActive = 0
      this.microArea = event?.micro_area || ''
      this.mes = null
      this.resetDadosMicroArea()

      if (event && this.microArea) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }

      this.setarPercentualMicroArea()
    },

    /**
     * Busca os cadastros da equipe selecionada.
     *
     * @returns {Promise<void>}
     */
    async buscarCadastrosPorEquipe() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.equipe.ine_esb
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Busca os cadastros da microárea selecionada.
     *
     * @returns {Promise<void>}
     */
    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorMicroArea(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.microArea
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Calcula e atualiza o percentual do município.
     */
    setarPercentualMunicipio() {
      const resultado = Functions.percentualMunicipio(
        this.dadosGraficoPercentual,
        this.tipoResultadoPercentual
      )
      Object.assign(this.dadosPercentualMunicipio, resultado)
      this.$refs.graficoPercentual.serieHistoricaMunicipio(
        this.dadosGraficoPercentual
      )
    },

    /**
     * Calcula e atualiza o percentual da equipe.
     */
    setarPercentualEquipe() {
      const resultado = Functions.percentualEquipe(
        this.dadosGraficoPercentual,
        this.equipe.ine_esb,
        this.tipoResultadoPercentual
      )
      Object.assign(this.dadosPercentualEquipe, resultado)
      this.$refs.graficoPercentual.serieHistoricaEquipe(
        this.dadosGraficoPercentual,
        this.equipe
      )
    },

    /**
     * Calcula e atualiza o percentual da microárea.
     */
    async setarPercentualMicroArea() {
      if (!this.microArea) return
      const resultado = Functions.percentualMicroArea(
        this.dadosGraficoPercentual,
        this.equipe.ine_esb,
        this.microArea,
        this.tipoResultadoPercentual
      )
      Object.assign(this.dadosPercentualMicroArea, resultado)
      this.$refs.graficoPercentual.serieHistoricaMicroArea(
        this.dadosGraficoPercentual,
        this.equipe,
        this.microArea
      )
    },

    /**
     * Limpa a lista de cadastros carregados.
     */
    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    /**
     * Reseta os dados da equipe selecionada.
     */
    resetDadosEquipe() {
      this.equipe = ''
      this.dadosPercentualEquipe = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Reseta os dados da microárea selecionada.
     */
    resetDadosMicroArea() {
      this.dadosPercentualMicroArea = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Altera o tipo de resultado da tabela percentual.
     *
     * @param {String} tipo Tipo do resultado (mensal ou quadrimestral).
     */
    changeTipoResultadoPercentual(tipo) {
      this.tipoResultadoPercentual = tipo

      this.setarPercentualMunicipio()

      if (this.equipe) {
        this.setarPercentualEquipe()
      }

      if (this.microArea) {
        this.setarPercentualMicroArea()
      }
    },

    /**
     * Altera o tipo de resultado do gráfico.
     *
     * @param {String} tipo Tipo do resultado (mensal ou quadrimestral).
     */
    changeTipoResultadoGrafico(tipo) {
      this.tipoResultadoGrafico = tipo

      this.$nextTick(() => {
        this.$refs.graficoPercentual.serieHistoricaMunicipio(
          this.dadosGraficoPercentual
        )

        if (this.equipe) {
          this.$refs.graficoPercentual.serieHistoricaEquipe(
            this.dadosGraficoPercentual,
            this.equipe
          )
        }

        if (this.microArea) {
          this.$refs.graficoPercentual.serieHistoricaMicroArea(
            this.dadosGraficoPercentual,
            this.equipe,
            this.microArea
          )
        }
      })
    },

    /**
     * Gera o PDF com os cadastros exibidos.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.microArea
      )
    },

    /**
     * Inicializa  os dados
     */
    async init() {
      try {
        const response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[42]`
        )
        this.dadosGraficoPercentual = response2.data
        this.setarPercentualMunicipio()
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let nu_ine_profissional =
            this.$store.state.id_funcao == 8 ||
            this.$store.state.id_funcao == 14 ||
            this.$store.state.id_funcao == 15
              ? this.$store.state.nu_ine_vinculada
              : this.$store.state.nu_ine
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == nu_ine_profissional
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              ine_esb: equipe.ine_esb,
              no_equipe: equipe.no_esb,
            }
            this.buscarCadastrosPorEquipe()
            this.setarPercentualEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              ine_esb: equipe.ine_esb,
              no_equipe: equipe.no_esb,
            }
            this.setarPercentualEquipe()
          }

          this.microArea = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
          this.setarPercentualMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style scoped></style>
